export var LOG_LEVEL;
(function (LOG_LEVEL) {
    LOG_LEVEL[LOG_LEVEL["NONE"] = 0] = "NONE";
    LOG_LEVEL[LOG_LEVEL["ERROR"] = 1] = "ERROR";
    LOG_LEVEL[LOG_LEVEL["WARN"] = 2] = "WARN";
    LOG_LEVEL[LOG_LEVEL["INFO"] = 3] = "INFO";
    LOG_LEVEL[LOG_LEVEL["DEBUG"] = 4] = "DEBUG";
    LOG_LEVEL[LOG_LEVEL["TRACE"] = 5] = "TRACE";
})(LOG_LEVEL || (LOG_LEVEL = {}));
const levelsMap = {
    none: LOG_LEVEL.NONE,
    error: LOG_LEVEL.ERROR,
    warn: LOG_LEVEL.WARN,
    info: LOG_LEVEL.INFO,
    debug: LOG_LEVEL.DEBUG,
    trace: LOG_LEVEL.TRACE,
};
const DEFAULT_NAMESPACE = 'Sitecore Search SDK';
export class SDKLogger {
    constructor(transports, logLevel = LOG_LEVEL.NONE, namespace = DEFAULT_NAMESPACE) {
        Object.defineProperty(this, "NONE", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.NONE
        });
        Object.defineProperty(this, "ERROR", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.ERROR
        });
        Object.defineProperty(this, "WARN", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.WARN
        });
        Object.defineProperty(this, "INFO", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.INFO
        });
        Object.defineProperty(this, "DEBUG", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.DEBUG
        });
        Object.defineProperty(this, "TRACE", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.TRACE
        });
        Object.defineProperty(this, "transports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "logLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: LOG_LEVEL.NONE
        });
        Object.defineProperty(this, "namespace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: DEFAULT_NAMESPACE
        });
        this.transports = transports;
        this.namespace = namespace;
        this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (typeof logLevel !== 'string') {
            this.logLevel = logLevel;
        }
        else if (!levelsMap[logLevel]) {
            throw new Error(`Logger :: Invalid logLevel (${logLevel})`);
        }
        else {
            this.logLevel = levelsMap[logLevel];
        }
    }
    send(logLevel, method, ...args) {
        try {
            if (this.logLevel >= logLevel) {
                this.transports.forEach((t) => {
                    t[method](this.namespace, ' ::: ', ...args);
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    error(...args) {
        return this.send(LOG_LEVEL.ERROR, 'error', ...args);
    }
    warn(...args) {
        return this.send(LOG_LEVEL.WARN, 'warn', ...args);
    }
    info(...args) {
        return this.send(LOG_LEVEL.INFO, 'info', ...args);
    }
    debug(...args) {
        return this.send(LOG_LEVEL.DEBUG, 'debug', ...args);
    }
    trace(...args) {
        return this.send(LOG_LEVEL.TRACE, 'log', ...args);
    }
}
const transports = [console];
export const Logger = new SDKLogger(transports);
